import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SortableTree from 'react-sortable-tree';
import { AutoSizer } from 'react-virtualized';
import 'react-sortable-tree/style.css';
import theme, { textBold } from 'theme/theme';
import {
  RemoveRedEyeIcon,
  CreateNewFolderIcon,
  EditIcon,
  DeleteIcon,
  EmailIcon,
  NoteAddIcon,
} from 'base/components/Icon';
import Flex from 'base/components/Flex';
import Tag from 'base/components/Tag';
import PermissionTreeTheme from './theme/index';


const TreeHeader = styled(Flex)`
  background: ${theme.colors.light};
  padding: 15px 25px;
  @media (min-width: ${theme.breakpoints.desktop}) {
    padding: 15px 45px;
  }
  @media print {
    padding: 10px 0;
  }
`;

const ColumnGroup = styled.div`
  margin-left: 45px;
  border-left: 1px solid ${theme.colors.mediumLight};
`;

const ColumnGroupWithQuickActions = styled(ColumnGroup)`
  padding-right: 57px;
  @media print {
    padding-right: 0;
  }
`;

const HeaderLabel = styled.div`
  font-size: ${theme.fontSizes.default};
  ${textBold}
  padding-left: 15px;
`;

const iconProps = {
  size: '23px',
  style: { margin: '5px 16px' },
  color: theme.colors.medium,
};

const PermissionTree = ({
  treeData, width, height, ...other
}) => (
  <div style={{ width: '100%' }}>
    <TreeHeader
      flexDirection="row"
      justifyContent="flex-end"
    >
      <ColumnGroupWithQuickActions>
        <HeaderLabel>Folder Permissions</HeaderLabel>
        <RemoveRedEyeIcon {...iconProps} />
        <CreateNewFolderIcon {...iconProps} />
        <EditIcon {...iconProps} />
        <DeleteIcon {...iconProps} />
      </ColumnGroupWithQuickActions>
      <ColumnGroupWithQuickActions>
        <HeaderLabel>Document Permissions</HeaderLabel>
        <RemoveRedEyeIcon {...iconProps} />
        <NoteAddIcon {...iconProps} />
        <EditIcon {...iconProps} />
        <DeleteIcon {...iconProps} />
        <EmailIcon {...iconProps} />
      </ColumnGroupWithQuickActions>
      <ColumnGroup className="print-hide">
        <HeaderLabel>Inherit</HeaderLabel>
        <Tag style={{ margin: '0 15px' }}>from parent</Tag>
      </ColumnGroup>
    </TreeHeader>
    <AutoSizer>
      {(autoSizerProps) => (
        <SortableTree
          theme={PermissionTreeTheme}
          treeData={treeData}
          canDrag={false}
          onChange={() => {}}
          scaffoldBlockPxWidth={22}
          rowHeight={75}
          isVirtualized
          reactVirtualizedListProps={{
            ...autoSizerProps,
          }}
          {...other}
        />
      )}
    </AutoSizer>
  </div>
);
PermissionTree.propTypes = {
  treeData: PropTypes.arrayOf(PropTypes.object).isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
};
PermissionTree.defaultProps = {
  height: '500px',
  width: '100%',
};

export default styled(PermissionTree)`
  .rst__placeholder {
    height: 0;
    padding: 0;
  }
  .rst__placeholder::before {
    border: 0;
  }
`;
